import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import {
  push
} from 'react-router-redux';
import {
  Segment
} from 'semantic-ui-react';
import feathersConnect from './../../../providers/feathersConnect';
import AList from './../../auto/AList';

const PAGE_RANGE = 10;

class CoopAsocadosView extends Component {

  constructor (props) {
    super(props);

    this.PersonaService = this.props.feathers.service('/api/personas');
    this.AsociadoService = this.props.feathers.service('/api/asociados');
  }

  componentDidMount () {

  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    let personaSelectConfig = {
      service: this.PersonaService,
      params: {
        query: {
          CooperativaId: this.props.cooperativa.id,
          skip: 0,
          limit: 99999
        }
      },
      mapFunction: (persona, index) => {
        return {
          key: index,
          text: `${persona.apellido}, ${persona.nombre} (${persona.dni})`,
          value: persona.id
        };
      }
    };

    return (
      <div>
        <AList
          pageRange={PAGE_RANGE}
          mapFunction={(asociado) => ({
            id: asociado.id,
            header: `${asociado.persona.apellido}, ${asociado.persona.nombre}`,
            description: `DNI ${asociado.persona.dni}`
          })}
          service={this.AsociadoService}
          options={{
            serviceParams: {
              CooperativaId: this.props.cooperativa.id
            }
          }}
          form={{
            fields: [
              ['!Persona', 'PersonaId', 'asyncselect', 10, personaSelectConfig]
            ],
            service: this.AsociadoService,
            options: {
              serviceParams: {
                CooperativaId: this.props.cooperativa.id
              }
            }
          }} />
      </div>
    );
  }
}

export default feathersConnect(
  connect(
    CoopAsocadosView.mapStateToProps,
    CoopAsocadosView.mapDispatchToProps
  )(CoopAsocadosView)
);



// WEBPACK FOOTER //
// ./client/components/pages/cooperativas/CoopAsociadosView.js